import React from 'react'
import header from './HeaderContact.module.scss'

const HeaderContact = ({isOpen}) => {

    return (
        <div className={header.contacts}>
            <div className={header.box_phone}>
                <a className={header.phone} href="tel:+79777238808" target='_blank' rel='noopener noreferrer'>+7 (977) 723-88-08</a>
            </div>
        </div>
    );
};

export default HeaderContact